module.exports = "<dt-content-header state-title=\"'Dashboard'\"></dt-content-header> <div layout=row layout-align=\"start start\" lex> <div class=placeholder-block layout-margin> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <div class=placeholder-block__content> <img src=/assets/images/dashboards.png class=placeholder-block__image alt=\"This functionality don't supported\"> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/dashboard/dashboard.html
// module id = Hbnl
// module chunks = 1